import { useEffect, useState } from "react";
import axios from "axios";
const UseAll = () => {
  const [products, setProducts] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  
  useEffect(() => {
    const fetchProducts = async () => {
      try {
        setIsLoading(true);
        setError(null);
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/getAll`
        );
        setProducts(response.data.categories);
      } catch (err) {
        setError(err.message || 'Failed to fetch categories');
        console.error('Error fetching categories:', err);
      } finally {
        setIsLoading(false);
      }
    };
    fetchProducts();
  }, []);
  
  return { products, isLoading, error };
};

export default UseAll;
